import { Table, Tbody, Td, Text, Th, Thead, Tr } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useGetPortalMyBidsQuery } from "../../../../autogen/bff-api";
import { useDisplayDate } from "../../../../common/formatting/useDisplayDate";
import { urls } from "../../../../urls";
import { BidV2StatusTag } from "../../sourcing-event/BidV2StatusTag";
import { HomePanel } from "./HomePanel";

const DISPLAY_LIMIT = 6;

export const MyBidsPanel = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const displayDate = useDisplayDate();

  const { data, isLoading, isError } = useGetPortalMyBidsQuery({});
  const bids = (data?.bids ?? []).slice(0, DISPLAY_LIMIT);

  return (
    <HomePanel titleKey="My bids" seeAllTo={urls.v2.supplier.bids} isLoading={isLoading} isError={isError} isEmpty={bids.length === 0} emptyKey="No offers yet">
      <Table variant="simple" size="sm">
        <Thead><Tr><Th>{t("Title")}</Th><Th>{t("Status")}</Th><Th>{t("Deadline")}</Th></Tr></Thead>
        <Tbody>
          {bids.map((bid) => (
            <Tr key={bid.event.id} cursor="pointer" _hover={{ bg: "smPrimarySofter" }} onClick={() => navigate(urls.v2.supplier.procurement.go(bid.eventId))}>
              <Td fontWeight="medium" color="smText">{bid.event.title || t("Untitled")}</Td>
              <Td><BidV2StatusTag status={bid.status} size="sm" /></Td>
              <Td>
                <Text fontSize="sm" color="smMuted">
                  {bid.event.bidSubmissionDeadline ? displayDate(bid.event.bidSubmissionDeadline) : "—"}
                </Text>
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </HomePanel>
  );
};
